var _defs, _path, _path2, _rect, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 828.53 678.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #ff5e46;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #2d1e3c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.43,217.76h0c43.3,0,78.46,35.16,78.46,78.46v382.3h-156.92v-382.3c0-43.3,35.16-78.46,78.46-78.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M563.51,159.91h0c43.3,0,78.46,35.16,78.46,78.46v439.82h-156.92V238.37c0-43.3,35.16-78.46,78.46-78.46Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 256.28,
    y: 376.42,
    width: 76.98,
    height: 108.07,
    rx: 38.49,
    ry: 38.49
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 546.44,
    y: 376.42,
    width: 76.98,
    height: 108.07,
    rx: 38.49,
    ry: 38.49
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M828.53,528.88v149.15h-53.26c-.03.07-.07.12-.1.17h-151.59V238.6c0-17.53-7.17-33.47-18.72-45.02-11.55-11.55-27.49-18.73-45.02-18.73-33.69,0-61.5,26.51-63.62,59.69-.08,1.34-.14,2.69-.14,4.07v439.6h-162.51c.19-1.95.29-3.93.29-5.93v-371.43c0-17.53-7.17-33.47-18.72-45.02-11.55-11.55-27.49-18.72-45.02-18.72-35.06,0-63.76,28.68-63.76,63.74v371.43c0,2,.1,3.98.29,5.93H42.57v-366.83H0v-149.15h204.93v60c1.17-1.22,2.39-2.41,3.64-3.56v-.02l125.08-124.91c2.54-2.88,5.27-5.59,8.15-8.13l.24-.25.03.02c16.38-14.36,37.79-23.12,61.17-23.12,51.16,0,92.99,41.86,92.99,92.99v3.17c.68-.68,1.37-1.34,2.07-1.98v-.02l125.08-124.92c2.54-2.88,5.27-5.59,8.15-8.13l.24-.24h.03c16.38-14.36,37.79-23.12,61.17-23.12,51.16,0,93.01,41.86,93.01,93.01v435.87h42.57Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotM);
export default __webpack_public_path__ + "static/media/mascot-m.18eb3d3b71b9315cf5b8373a85edf009.svg";
export { ForwardRef as ReactComponent };